module.exports = __webpack_public_path__ + "img/Milk.57570341.png";